var ezdia;
(function (ezdia) {
    function render(props) {
        var e_1, _a;
        var exportCols = props.exportCols;
        var content = {
            selectAll: true,
            colList: exportCols
        };
        try {
            for (var exportCols_1 = __values(exportCols), exportCols_1_1 = exportCols_1.next(); !exportCols_1_1.done; exportCols_1_1 = exportCols_1.next()) {
                var hidden = exportCols_1_1.value.hidden;
                if (hidden) {
                    content.selectAll = false;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (exportCols_1_1 && !exportCols_1_1.done && (_a = exportCols_1.return)) _a.call(exportCols_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        exportPopover.call(this, props, content);
    }
    function exportPopover(props, content) {
        var popover = $(this).popupList({
            content: content,
            itemTemplate: 'grid-column-export',
            placement: function (context) {
                $(context).multiItemCheckList();
                return 'auto';
            },
            buttons: {
                Export: function () {
                    exports(props);
                    popover.popupList('destroy');
                },
                Reset: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var settingData, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    settingData = ezdia.util.getUserSettingData({
                                        action: 'export'
                                    });
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, ezdia.util.clearUserSettings(settingData)];
                                case 2:
                                    _a.sent();
                                    popover.popupList('destroy');
                                    window.location.reload();
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    });
                },
                Save: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var arr, exportColumns, settingData, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    arr = getExportColumns();
                                    exportColumns = arr.join(',');
                                    settingData = ezdia.util.getUserSettingData({
                                        action: 'export',
                                        columnValue: exportColumns
                                    });
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, ezdia.util.saveUserSettings(settingData)];
                                case 2:
                                    _a.sent();
                                    refreshColModel('export');
                                    exports(props);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    return [3 /*break*/, 4];
                                case 4:
                                    popover.popupList('destroy');
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
            }
        });
        $('body')
            .off('.ez.export.body.click')
            .on('click.ez.export.body.click', function click(e) {
            var par = "#popover_" + popover.attr('id');
            var isElem = popover.attr('id') === $(e.target).attr('id');
            if (!$(e.target).parents(par).length && !isElem) {
                popover.popupList('destroy');
                $(this).off('.columnExportBodyClick');
            }
        });
    }
    function getExportColumns() {
        var arr = [];
        var isAll = $("input[data-column='export all']").is(':checked');
        if (!isAll) {
            $("input[data-column='export']:checkbox:checked").each(function each() {
                var value = this.value;
                if (value.toLowerCase() === 'id') {
                    return;
                }
                arr.push(value);
            });
        }
        return arr;
    }
    function exports(props) {
        var _a = $.ezdia.config.pageParams, accountName = _a.account, role = _a.role, tab = _a.tab, formtype = _a.formType;
        var query = props.query;
        var selectedColumn = getExportColumns();
        var customFields = selectedColumn.length
            ? "id," + getExportColumns()
            : '';
        var reqData = {
            accountName: accountName,
            role: role,
            tab: tab,
            customFields: customFields,
            formtype: formtype,
            searchString: query
        };
        exportAjax(props, reqData);
    }
    function exportAjax(props, data) {
        var $preparingFileModal = $('#preparing-file-modal');
        var _a = props.url, url = _a === void 0 ? "export.htm" : _a;
        $.fileDownload(url, {
            data: data,
            preparingMessageHtml: 'We are preparing your report, please wait...',
            // failMessageHtml: "There was a problem generating your report, please try again.",
            httpMethod: 'POST',
            datatype: 'json',
            successCallback: function () {
                $preparingFileModal.dialog('close');
            },
            failCallback: function (response) {
                if (typeof response === 'string') {
                    var noHTML = /(<([^>]+)>)/gi;
                    var responseStrig = response.replace(noHTML, '');
                    var responseJson = ezdia.util.jsonParse(responseStrig);
                    var success = responseJson.success;
                    if (success) {
                        ezdia.util.showSuccessError({
                            message: success
                        });
                    }
                    else {
                        showExportError();
                        $preparingFileModal.dialog('close');
                    }
                }
                else {
                    showExportError();
                    $preparingFileModal.dialog('close');
                }
                $('#error-modal').dialog({ modal: true });
            }
        });
    }
    function showExportError() {
        ezdia.util.showSuccessError({
            message: 'There was a problem generating your report, please try again.',
            error: true,
            autohide: false
        });
    }
    var component;
    (function (component) {
        function exportGridData(element, props) {
            var _a;
            var thisType = element;
            if (element instanceof jQuery) {
                _a = __read(element, 1), thisType = _a[0];
            }
            render.call(thisType, props);
        }
        component.exportGridData = exportGridData;
    })(component = ezdia.component || (ezdia.component = {}));
})(ezdia || (ezdia = {}));
